var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box box-success" }, [
    _c("div", { staticClass: "box-header" }, [
      _c("i", { staticClass: "fa fa-thumb-tack" }),
      _vm._v(" "),
      _c("h3", { staticClass: "box-title" }, [
        _vm._v(_vm._s(_vm.latestNotification.title)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "mailbox-read-time pull-right" }, [
        _c("time", { attrs: { datetime: _vm.latestNotification.start } }, [
          _vm._v(_vm._s(_vm.latestNotification.start_formatted)),
        ]),
        _vm._v("\n            -\n            "),
        _c("time", { attrs: { datetime: _vm.latestNotification.end } }, [
          _vm._v(_vm._s(_vm.latestNotification.end_formatted)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box-body" },
      [
        _c(
          "div",
          { domProps: { innerHTML: _vm._s(_vm.latestNotification.text) } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.latestNotification.text) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            domProps: {
              innerHTML: _vm._s(_vm.latestNotification.attachments_template),
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.latestNotification.attachments_template) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("mark-as-read-button", {
          attrs: {
            "latest-notification": _vm.latestNotification,
            "read-route": _vm.latestNotification.read_route,
            "mark-as-read-string": _vm.markAsReadString,
            read: _vm.read,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }